export enum ConditionSeverity {
  SCT_24484000 = 'Severe',

  SCT_6736007 = 'Moderate',

  SCT_255604002 = 'Mild',
}
